import React from "react";
import { getLanguageFile } from "../common/GetLanguageFile";

function SceneDelConfirmPanel(props: {
  setIsDeletingScene: React.Dispatch<React.SetStateAction<boolean>>;
  handleSceneDelete: () => void;
  children?: JSX.Element;
  differentConfirmBtnMessage?: string;
}) {
  const {
    handleSceneDelete,
    setIsDeletingScene,
    children,
    differentConfirmBtnMessage,
  } = props;

  return (
    <div className="scene-deletion-confirm">
      <div className="scene-deletion-confirm-elem">
        <div>{children}</div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            className="deletion-confirm"
            onClick={() => setIsDeletingScene(false)}
          >
            {getLanguageFile("generics.cancel")}
          </button>

          <button
            className="deletion-confirm delete"
            onClick={() => {
              setIsDeletingScene(false);
              handleSceneDelete();
            }}
          >
            {differentConfirmBtnMessage ?? getLanguageFile("generics.delete")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SceneDelConfirmPanel;
